console.log("Iurop functions!")

function enableCart() {
  document.querySelector('.toggle-cart-class')?.classList.add('loaded-cart');

  setTimeout(() => {
    document.querySelector('.toggle-cart-class')?.classList.add('loaded-cart');
  }, 500);
}

function buildExtraString(value) {
  const mapping = window.variantSizeMapping || {};
  const text = mapping[value];

  if (!text) return '';

  const svgIcon = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.66406 0.75C8.64844 0.75 9.52344 1.32422 9.96094 2.17188C10.8633 1.87109 11.9023 2.08984 12.6133 2.80078C13.3242 3.51172 13.543 4.55078 13.2422 5.45312C14.0898 5.89062 14.6641 6.76562 14.6641 7.75C14.6641 8.76172 14.0898 9.63672 13.2422 10.0742C13.543 10.9766 13.3242 11.9883 12.6133 12.6992C11.9023 13.4102 10.8633 13.6289 9.96094 13.3555C9.52344 14.2031 8.64844 14.75 7.66406 14.75C6.65234 14.75 5.77734 14.2031 5.33984 13.3555C4.4375 13.6289 3.42578 13.4102 2.71484 12.6992C2.00391 11.9883 1.78516 10.9766 2.05859 10.0742C1.21094 9.63672 0.664062 8.76172 0.664062 7.75C0.664062 6.76562 1.21094 5.89062 2.05859 5.45312C1.78516 4.55078 2.00391 3.51172 2.71484 2.80078C3.42578 2.08984 4.4375 1.87109 5.33984 2.17188C5.77734 1.32422 6.65234 0.75 7.66406 0.75ZM10.7539 6.46484C11 6.21875 11 5.80859 10.7539 5.5625C10.4805 5.28906 10.0703 5.28906 9.82422 5.5625L6.78906 8.59766L5.50391 7.3125C5.23047 7.03906 4.82031 7.03906 4.57422 7.3125C4.30078 7.55859 4.30078 7.96875 4.57422 8.21484L6.32422 9.96484C6.57031 10.2383 6.98047 10.2383 7.25391 9.96484L10.7539 6.46484Z" fill="#E9AFAF"></path></svg>';

  return `<div class="extra">${svgIcon} ${text}</div>`;
}

function updateBundleVariantTitles() {
  if (!document.querySelector('.h2.product-single__title')) return;

  const productTitleEl = document.querySelector('.h2.product-single__title');
  const titleBase = normalizeTitle(productTitleEl.textContent || '').split('®')[0].trim();
  const selectors = document.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper');

  if (!selectors.length) return;

  for (let i = 0; i < selectors.length; i++) {
    const selector = selectors[i];
    const optionGroups = selector.querySelectorAll('.kaching-bundles__swatch-buttons.kaching-bundles-option');
    let value1 = '';
    let value2 = '';

    if (optionGroups[0]) {
      const selected = optionGroups[0].querySelector('.kaching-bundles__swatch-buttons__button--selected');
      value1 = selected ? selected.getAttribute('data-value') : '';
    }

    if (optionGroups[1]) {
      const selected = optionGroups[1].querySelector('.kaching-bundles__swatch-buttons__button--selected');
      value2 = selected ? selected.getAttribute('data-value') : '';
    }

    const numberEl = selector.querySelector('.kaching-bundles__bar-variant-number');
    if (!numberEl) continue;

    const selectedValues = formatSelectedValues(value1, value2);
    const extraString = buildExtraString(value2);

    const selectedMarkup = selectedValues ? `<span class="selecteds">${selectedValues} ${extraString}</span>` : '';
    numberEl.innerHTML = `<span>${titleBase}</span>${selectedMarkup}`;
  }
}

function updateVariantTitles() {
  if (!document.querySelector('.h2.product-single__title')) return;

  const selectors = document.querySelectorAll('.label.variant__label');
  if (!selectors.length) return;

  for (let i = 0; i < selectors.length; i++) {
    const selector = selectors[i];
    let stringInitial = 'Copa'

    if (selector.innerHTML.includes('Ancho de la cinta')) {
      stringInitial = 'Ancho de la cinta'
    }

    if (selector.innerHTML.includes('Copa') || selector.innerHTML.includes('Talla') || selector.innerHTML.includes('Ancho de la cinta')) { 
      const selectedOption = selector.closest('.variant-button-wrap').querySelector('input[type=radio]:checked+label');

      if (selectedOption) {
        const selectedOptionValue = selectedOption.innerHTML.trim();
        const extraString = buildExtraString(selectedOptionValue);
        selector.innerHTML = `${stringInitial} ${extraString}`;
      }
    }
  }
}

function applyDynamicMargin() {
  const sources = document.querySelectorAll('.section-featured-collection-products');

  sources.forEach((source, index) => {
    const el = source;
    const leftDistance = el.getBoundingClientRect().left;
  });
}

let resizeTimeout;

window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    applyDynamicMargin();
  }, 150);
});


function applyDynamicSizes() {
  const allPacks = document.querySelector('.kaching-bundles__bars');
  const selectedPack = document.querySelector('.kaching-bundles__bars .kaching-bundles__bar.kaching-bundles__bar--selected');

  if (!allPacks) return;

  if (selectedPack) {
    const indexSelected = Array.from(allPacks.children).indexOf(selectedPack);

    allPacks.classList.remove('is-one-product')
    allPacks.classList.remove('is-two-products')
    allPacks.classList.remove('is-three-products')

    if (indexSelected == 0) {
      allPacks.classList.add('is-one-product')
    }
    if (indexSelected == 1) {
      allPacks.classList.add('is-two-products')
    }
    if (indexSelected == 3) {
      allPacks.classList.add('is-three-products')
    }
    console.log("Selected pack!", selectedPack, indexSelected)
  }

}

function normalizeTitle(text) {
  if (!text) return '';
  return text.replace(/\uFE0F/g, '').trim();
}

function formatSelectedValues(value1, value2) {
  const values = [value1, value2].filter((value) => value && value !== 'false');
  return values.join(' - ');
}

function sanitizeCollectionText() {
  const titleEls = document.querySelectorAll('.grid-product__title');
  titleEls.forEach((el) => {
    const original = el.textContent || '';
    const cleaned = normalizeTitle(original)
      .replace(/\s*\|\s*false\s*-\s*false/gi, '')
      .replace(/false\s*-\s*false/gi, '')
      .replace(/\s{2,}/g, ' ')
      .trim();

    if (cleaned && cleaned !== original.trim()) {
      el.textContent = cleaned;
    }
  });
}

window.addEventListener('load', function () {
  enableCart();
});

document.addEventListener('DOMContentLoaded', function () {
  console.log("Initializer")
   
  applyDynamicMargin();
  applyDynamicSizes();
  sanitizeCollectionText();

  setTimeout(() => {
    const filterGroupPrice = document.querySelector('.filter-form div[data-collapsible-id="filter-precio"]')
    if (filterGroupPrice) {
      const trigger = filterGroupPrice.closest('.collection-sidebar__group').querySelector('.collapsible-trigger-btn')

      if (trigger) trigger.click()
    }

    const navMobile = document.querySelector('.site-nav__icons')
    if (navMobile) {
      navMobile.classList.add('show-nav')
    }
    
  }, 1300);

  setInterval(() => {
    const widgetReviews = document.querySelector(".template-index .loox-trust-badge-container.loox-widget");
    const targetContainer = document.querySelector(".template-index .hero__text-wrap .hero__subtitle");

    const alreadyMove = document.querySelector(".template-index .hero__text-wrap .hero__subtitle .loox-widget");

    if (widgetReviews && !alreadyMove) {
      targetContainer.appendChild(widgetReviews);
    }

    updateBundleVariantTitles();
    sanitizeCollectionText();
    updateVariantTitles();

  }, 1000);

  document.querySelector('.close-drawer-header').addEventListener('click', () => {
    // location.reload();
    document.querySelector('.site-nav__close-cart').click()
  });

  document.addEventListener('change', function(e) {
    if (e.target.id === 'secure-shipping') {
      const isChecked = e.target.checked;
      const addSecureShippButton = e.target.closest('.cart-segure-shpping').querySelector('.quick-add-secure-shipping button')

      if (isChecked) {
        console.log("Add", addSecureShippButton)

        if (addSecureShippButton) {
          addSecureShippButton.click()
        }
      } else {
        console.log("Rermove")
        const removeSecureButton = e.target.closest('.cart__scrollable').querySelector('.cart__item.is-secure-item .js-qty__num')
        if (removeSecureButton) {
          removeSecureButton.value = 0;

          removeSecureButton.dispatchEvent(new Event('input', { bubbles: true }));
          removeSecureButton.dispatchEvent(new Event('change', { bubbles: true }));

        }
      }
    }
  });

});

